import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const NextCard: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--nextcard')}
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M20,12.8638154 L16.3808384,17 L20,17 L20,12.8638154 Z M13.9084051,17 L20,10.0381773 L20,8 L5,8 L5,17 L13.9084051,17 Z M4,18 L4,7 L21,7 L21,18 L4,18 Z"
        id="Email_S"
        fill="#000000"
        fillRule="nonzero"
      />
    </g>
  </svg>
);

export default NextCard;
